import { useEffect, useState } from 'react'

/**
 * Hook to track page/tab visibility state.
 * Returns true when the page is visible, false when hidden.
 *
 * Used to pause polling when the tab is in the background.
 */
export function usePageVisibility(): boolean {
  const [isVisible, setIsVisible] = useState(() => !document.hidden)

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden)
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [])

  return isVisible
}
